import { useQuery } from '@tanstack/react-query';
import { getData } from './base';
import type { HealthVersion } from './models/healthVersion';

// List of microservices that have health/version endpoints
export const MICROSERVICES = ['contents', 'membership', 'rules'];

// Hook to fetch health/version for a specific service
const useServiceHealth = (serviceName: string) => {
	return useQuery<HealthVersion, Error>(
		['health', serviceName],
		getData(`/${serviceName}/health/version`, { onlyPublic: true }),
		{
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			retry: 3,
			staleTime: 5 * 60 * 1000, // 5 minutes
		},
	);
};

// Hook to fetch health/version for all services
const useAllServicesHealth = () => {
	// Call hooks at the top level for each service
	const contentsHealth = useServiceHealth('contents');
	const membershipHealth = useServiceHealth('membership');
	const rulesHealth = useServiceHealth('rules');

	// Return array with service names and their corresponding queries
	return [
		{ serviceName: 'contents', query: contentsHealth },
		{ serviceName: 'membership', query: membershipHealth },
		{ serviceName: 'rules', query: rulesHealth },
	];
};

export default {
	useServiceHealth,
	useAllServicesHealth,
	MICROSERVICES,
};
